/** Translation hints are evidence, not proof of which extension changed the DOM. */
export function getDomMutationDiagnostics(error?: Error): Record<string, string | boolean> {
  const message = error?.message || '';
  const domOperationFailure = /(?:insertBefore|removeChild|replaceChild)/.test(message)
    && /(?:not a child|node to be|Node)/i.test(message);
  const hydrationFailure = /Minified React error #418\b|Hydration failed because/i.test(message);
  if ((!domOperationFailure && !hydrationFailure) || typeof document === 'undefined') return {};

  // Record only known markers, never arbitrary classes, page text or DOM HTML.
  const root = document.documentElement;
  const markers = ['translated-ltr', 'translated-rtl'].filter((name) => root.classList.contains(name));
  return {
    domOperationFailure,
    browserTranslationDetected: markers.length > 0,
    browserTranslationMarkers: markers.join(','),
    documentLanguage: root.lang.slice(0, 32),
  };
}
